import React from 'react';
import { SlideDown } from 'react-slidedown';
import { connect } from 'react-redux';
import { logout } from '../utils/login-util';
import { verifyToken } from '../utils/token-util';
import SearchInput from '../components/GeneralForm/SearchInput';
import { history } from '../utils/navigation-util';
import bn from '../utils/bemnames';
import 'react-slidedown/lib/slidedown.css';
import pathConst from '../constants/PathsConstant';
import { QUERY_SELECTOR_SIDEBAR, QUERY_SELECTOR_SIDEBAR_OPEN } from '../constants/ScreenSizeConstant';
import { dateToNull, GetForeignSecurityKey } from '../utils/general-util';
import NotificationComponent from '../components/GeneralForm/NotificationComponent';
import { TRIAL_USER, FULL_USER, FORBIDDEN_USER } from '../constants/NumberConstants';
import YellowStatusBar from '../components/GeneralForm/YellowStatusBar';
import TypeConstants from '../constants/TrialTypeConstants';
import { ACTIVIST_INSIGHT_MONTHLY, STEWARDSHIP } from '../constants/ProductConstants';
import { isSsoBasedOnUrl } from '../utils/app-utils';
import { toggleSideBar } from '../features/LayoutContainer/SideBarSlice';
import { scheduleProactiveRefresh } from '../api';

const bem = bn.create('header');
const isHighbondUsers = isSsoBasedOnUrl(window.location.hostname);

class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpenUserCardPopover: false,
      isOpenAlertNotification: false,
      Membership: [],
      UserEmailName: '',
      UserEmailDomain: '',
      sessionid: '',
      userid: '',
      isRedDotDisplay: true,
      userTrialStatus: '',
      UserEmail: '',
      showProxyIcon: null,
      showActivistIcon: null,
      highbondUserInfo: isHighbondUsers ? JSON.parse(window.localStorage.getItem('userInfo')) : false,
    };

    // Bind methods
    this.initializeUserData = this.initializeUserData.bind(this);
    this.redirectToLogin = this.redirectToLogin.bind(this);
    this.toggleAlertNotificationPopover = this.toggleAlertNotificationPopover.bind(this);
    this.toggleChangeRedDot = this.toggleChangeRedDot.bind(this);
    this.handleSidebarControlButton = this.handleSidebarControlButton.bind(this);
    this.toggleUserCardPopover = this.toggleUserCardPopover.bind(this);
    this.toggleFeedbackPopover = this.toggleFeedbackPopover.bind(this);
    this.handleLogout = this.handleLogout.bind(this);

    this.initializeUserData();
  }

  async initializeUserData() {
    try {
      const token = window.localStorage.getItem('token');
      if (!token) {
        this.redirectToLogin();
        return;
      }

      const userData = await verifyToken(token);

      // Schedule a proactive refresh before this token expires so the user is
      // never signed out while the app is open. Use the current localStorage
      // value in case verifyToken triggered a reactive refresh en route.
      scheduleProactiveRefresh(window.localStorage.getItem('token'));

      // Remove Insightia Monthly and Stewardship from modules list
      const filteredMembership = userData.membership.filter(
        (membership) => membership.product_id !== ACTIVIST_INSIGHT_MONTHLY && membership.product_id !== STEWARDSHIP,
      );

      this.setState({
        Membership: filteredMembership,
        UserEmailName: userData.email.substring(0, userData.email.lastIndexOf('@')),
        UserEmailDomain: userData.email.substring(userData.email.lastIndexOf('@')),
        userid: userData.userId,
        sessionid: userData.sessionId,
        userTrialStatus: userData.status,
        UserEmail: userData.email,
        showProxyIcon: userData.showProxyIcon,
        showActivistIcon: userData.showActivistIcon,
      });
    } catch (error) {
      this.redirectToLogin();
    }
  }

  redirectToLogin() {
    localStorage.removeItem('token');
    localStorage.removeItem('userEmail');
    window.sessionStorage.setItem('redirect', window.location.pathname + window.location.search);
    history.push(pathConst.CREDENTIAL_FORM);
  }

  toggleAlertNotificationPopover() {
    this.setState({
      isOpenAlertNotification: !this.state.isOpenAlertNotification,
      isOpenUserCardPopover: this.state.isOpenUserCardPopover
        ? !this.state.isOpenUserCardPopover
        : this.state.isOpenUserCardPopover,
    });
    if (this.props.isAnyNotification) {
      localStorage.setItem(
        'alertNotificationData',
        JSON.stringify({ data: this.props.top20AlertData, firstLoad: false }),
      );
    }
  }

  toggleChangeRedDot() {
    this.setState({
      isRedDotDisplay: false,
    });
  }

  handleSidebarControlButton(event) {
    event.preventDefault();
    event.stopPropagation();
    this.props.toggleSideBar();
    document.querySelector(QUERY_SELECTOR_SIDEBAR).classList.toggle(QUERY_SELECTOR_SIDEBAR_OPEN);
  }

  toggleUserCardPopover() {
    this.setState({
      isOpenUserCardPopover: !this.state.isOpenUserCardPopover,
      isOpenAlertNotification: this.state.isOpenAlertNotification
        ? !this.state.isOpenAlertNotification
        : this.state.isOpenAlertNotification,
    });
  }
  toggleFeedbackPopover() {
    this.setState({
      isOpenUserCardPopover: this.state.isOpenUserCardPopover
        ? !this.state.isOpenUserCardPopover
        : this.state.isOpenUserCardPopover,
      isOpenAlertNotification: this.state.isOpenAlertNotification
        ? !this.state.isOpenAlertNotification
        : this.state.isOpenAlertNotification,
    });
  }

  async handleLogout() {
    try {
      await logout(this.state.userid, this.state.sessionid);
    } catch {
      // logout() clears client session in `finally`; still send user to login if the API fails
    }
    window.location.href = pathConst.CREDENTIAL_FORM;
  }

  renderComingSoonTag() {
    return (
      <div className="d-flex justify-content-between">
        <span className="comingSoonName">My Alerts</span>
        <div className="coming-soon-tag">Coming soon</div>
      </div>
    );
  }

  render() {
    return (
      <nav
        className={
          this.props.trialProductStatus && this.props.trialProductStatus !== TypeConstants.NOT_TRIAL_USER
            ? bem.b('navbar navbar-expand navbar-light yellowtrial')
            : `${bem.b('navbar navbar-expand navbar-light')}`
        }
      >
        <ul className="me-2">
          <button type="button" className="btn p-0 m-0" onClick={this.handleSidebarControlButton}>
            <i
              className="bi bi-list"
              style={
                this.props.trialProductStatus && this.props.trialProductStatus !== TypeConstants.NOT_TRIAL_USER
                  ? { fontSize: '1.7rem', color: '#1E1E1E' }
                  : { fontSize: '1.7rem', color: '#fff' }
              }
            />
          </button>
        </ul>
        <ul className="navbar-nav">
          <SearchInput
            isTrial={this.props.trialProductStatus && this.props.trialProductStatus !== TypeConstants.NOT_TRIAL_USER}
            univarsalCompanysearchFormReq={this.props.univarsalCompanysearchFormReq}
            univarsalInvestorsearchFormReq={this.props.univarsalInvestorsearchFormReq}
            univarsalAdvisorsearchFormReq={this.props.univarsalAdvisorsearchFormReq}
            univarsalPeopleSearchFormReq_V2={this.props.univarsalPeopleSearchFormReq_V2}
            handleEvent={this.props.handleEvent}
          />
        </ul>
        <ul className="navbar-nav">
          <YellowStatusBar
            distinctProfile={this.props.distinctProfile}
            trialProductStatus={this.props.trialProductStatus}
            userid={this.state.userid}
            userTrialStatus={this.state.userTrialStatus}
            UserEmail={this.state.UserEmail}
            url={this.props.location}
            ProductStatusNo={this.props.trialProductStatus}
            uniqueId={this.props.uniqueId}
            queryUniqueId={this.props.queryUniqueId}
            profileCount={this.props.profileCount}
            module={this.props.module}
            module_product_id={this.props.module_product_id}
          />
        </ul>
        <ul className={bem.e('nav-right navbar-nav')}>
          {/* HIDE BELL TEMPORARILY UNTIL ALERT / PDF  */}
          {/* showActivistIcon={showActivistIcon} */}
          {this.state.showProxyIcon && this.state.showProxyIcon !== null ? (
            <li className="d-inline-flex nav-item">
              <span
                id="navbarDropdown"
                className="nav-link"
                role="button"
                onClick={async () => {
                  await GetForeignSecurityKey({ userid: this.state.userid })
                    .then((res) => {
                      if (res && res.length > 0) {
                        const fsKey = res[0].foreign_security_key;
                        window.open(
                          `https://www.proxyinsight.com/crosslogin.aspx?ui=${this.state.userid}&fsk=${fsKey}`,
                          '_blank',
                        );
                      }
                    })
                    // eslint-disable-next-line no-console
                    .catch((e) => console.log(e));
                }}
                style={{ position: 'relative' }}
              >
                <img
                  alt="PI_project"
                  height={24}
                  width={24}
                  title="Proxy Insight"
                  src="https://www.proxyinsight.com/favicon-32x32.png"
                />
              </span>
            </li>
          ) : (
            ''
          )}
          {/* foreignSecurityKey={foreignSecurityKey} */}
          {this.state.showActivistIcon && this.state.showActivistIcon !== null ? (
            <li className="d-inline-flex nav-item">
              <span
                id="navbarDropdown"
                className="nav-link"
                role="button"
                onClick={async () => {
                  await GetForeignSecurityKey({ userid: this.state.userid })
                    .then((res) => {
                      if (res && res.length > 0) {
                        const fsKey = res[0].foreign_security_key;
                        window.open(
                          `https://www.activistinsight.com/crosslogin.aspx?ui=${this.state.userid}&fsk=${fsKey}`,
                          '_blank',
                        );
                      }
                    })
                    // eslint-disable-next-line no-console
                    .catch((e) => console.log(e));
                }}
                style={{ position: 'relative' }}
              >
                <img
                  alt="AI_project"
                  title="Activist Insight"
                  height={24}
                  width={24}
                  src="https://www.activistinsight.com/favicon-32x32.png"
                />
              </span>
            </li>
          ) : (
            ''
          )}

          <li className="d-inline-flex nav-item">
            <span
              id="navbarDropdown"
              className="nav-link"
              role="button"
              onClick={this.toggleFeedbackPopover}
              style={{ position: 'relative' }}
            >
              <svg
                id="feedback"
                className="bi bi-question-circle"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12ZM2.53488 12C2.53488 17.2274 6.77256 21.4651 12 21.4651C17.2274 21.4651 21.4651 17.2274 21.4651 12C21.4651 6.77256 17.2274 2.53488 12 2.53488C6.77256 2.53488 2.53488 6.77256 2.53488 12ZM13.3333 17.25C13.3333 17.8943 12.811 18.4167 12.1667 18.4167C11.5223 18.4167 11 17.8943 11 17.25C11 16.6057 11.5223 16.0833 12.1667 16.0833C12.811 16.0833 13.3333 16.6057 13.3333 17.25ZM12.1566 7.5C10.8179 7.5 10.0833 8.33768 10.0833 9.25933C10.0833 9.67355 9.74753 10.0093 9.33331 10.0093C8.9191 10.0093 8.58331 9.67355 8.58331 9.25933C8.58331 7.5499 9.94238 6 12.1566 6C14.3214 6 15.4166 7.63813 15.4166 9.25933C15.4166 10.2662 14.9877 11.1663 13.8446 12.309C12.9662 13.1874 12.75 13.6138 12.75 14.0833V14.75C12.75 15.1642 12.4142 15.5 12 15.5C11.5858 15.5 11.25 15.1642 11.25 14.75V14.0833C11.25 13.168 11.6469 12.3854 12.7841 11.2483C13.6628 10.3698 13.9166 9.83712 13.9166 9.25933C13.9166 8.36905 13.3356 7.5 12.1566 7.5Z"
                  fill={
                    this.props.trialProductStatus && this.props.trialProductStatus !== TypeConstants.NOT_TRIAL_USER
                      ? '#1E1E1E'
                      : 'white'
                  }
                />
              </svg>
            </span>
          </li>
          <li className="d-inline-flex nav-item">
            <span id="Popover1" className="position-relative nav-link">
              <div
                className="d-inline-block position-relative"
                onClick={() => {
                  this.toggleAlertNotificationPopover();
                  this.toggleChangeRedDot();
                }}
              >
                <svg
                  className="bi can-click animated infinite"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14.6772 3.02953C14.3505 1.69909 13.3119 0.75 12.0006 0.75C10.6881 0.75 9.64976 1.69877 9.32307 3.02954C8.12634 3.55518 7.18435 4.41114 6.6449 5.65849C6.11371 6.57045 5.99109 7.56326 5.9159 9.93352L5.90975 10.122C5.87175 11.2688 5.82285 11.8462 5.72006 12.1588C5.58244 12.5777 5.17654 12.9481 4.21173 13.608C3.83352 13.8676 3.68872 13.9713 3.51228 14.1179C3.36321 14.2418 3.23788 14.3636 3.13118 14.4933C2.70052 15.0174 2.63589 15.7309 2.9318 16.3698C3.03318 16.5898 3.18096 16.8009 3.36947 17.0066L3.59243 17.25H20.4079L20.6309 17.0066C20.8177 16.8027 20.9649 16.592 21.0677 16.3714L20.388 16.0545L21.0685 16.3698C21.3644 15.731 21.299 15.0174 20.8686 14.4936C20.7618 14.3637 20.6366 14.242 20.4879 14.1182C20.3112 13.9712 20.1629 13.8649 19.7895 13.6087C18.8238 12.9481 18.4179 12.5777 18.2803 12.159C18.1704 11.8262 18.1262 11.2564 18.0844 9.93363C18.0092 7.56326 17.8866 6.57046 17.3554 5.65849C16.816 4.41113 15.874 3.55516 14.6772 3.02953ZM19.7023 15.75H4.29793L4.29351 15.7407C4.23063 15.6049 4.23948 15.5072 4.28983 15.4459C4.32998 15.3971 4.38959 15.3392 4.47107 15.2715C4.59848 15.1656 4.72349 15.0761 5.05954 14.8455C6.31564 13.9863 6.86251 13.4872 7.14505 12.6272C7.31226 12.1187 7.36507 11.4952 7.40893 10.1717L7.41513 9.98161C7.48193 7.87576 7.59454 6.99125 7.95885 6.38334L8.00684 6.28865C8.42309 5.29928 9.20045 4.65386 10.2415 4.27699L10.6777 4.11909L10.7313 3.65831C10.8305 2.80418 11.3605 2.25 12.0006 2.25C12.6394 2.25 13.1699 2.80466 13.2691 3.65831L13.3226 4.11909L13.7588 4.27699C14.7999 4.65386 15.5772 5.29928 15.9935 6.28865L16.0415 6.38334C16.4058 6.99125 16.5184 7.87576 16.5852 9.98108C16.6332 11.5025 16.6791 12.0939 16.8557 12.6284C17.1378 13.4872 17.6847 13.9863 18.9417 14.8461C19.2731 15.0735 19.4008 15.1651 19.5283 15.2712C19.6097 15.3389 19.6694 15.3969 19.71 15.4463C19.7604 15.5076 19.7694 15.6051 19.7078 15.7385L19.7023 15.75ZM8.76413 19.4459L8.76074 19.4888L8.75812 19.5211C8.75275 19.5892 8.75001 19.6415 8.75001 19.7009C8.75001 21.7235 9.96062 23.25 11.9984 23.25C14.0375 23.25 15.25 21.7234 15.25 19.7009C15.25 19.642 15.2473 19.5868 15.2423 19.5222L15.237 19.458L15.2352 19.4369L15.1772 18.75H8.8145L8.76413 19.4459ZM13.7056 20.25C13.5445 21.1859 12.9496 21.75 11.9984 21.75C11.0488 21.75 10.455 21.1862 10.2943 20.25H13.7056Z"
                    fill={
                      this.props.trialProductStatus && this.props.trialProductStatus !== TypeConstants.NOT_TRIAL_USER
                        ? '#1E1E1E'
                        : 'white'
                    }
                  />
                </svg>
                {this.props.isAnyNotification && this.state.isRedDotDisplay ? (
                  <span className={bem.e('badge position-absolute badge-primary')} />
                ) : (
                  ''
                )}
              </div>
              <div
                className={
                  this.state.isOpenAlertNotification ? bem.b('alertdrop dropdown-menu show') : bem.b('dropdown-menu')
                }
                aria-labelledby="navbarDropdown"
                style={{ zIndex: 1003 }}
              >
                <SlideDown className="my-dropdown-slidedown">
                  <div
                    className="card alertNotificationCard"
                    style={{
                      width: '300px',
                      backgroundColor: 'transparent',
                    }}
                  >
                    {this.props.top20AlertData.length > 0 ? (
                      <div className="alertNotificationsList">
                        {this.props.top20AlertData.map((item, index) => (
                          <NotificationComponent
                            key={`Notification_${index + 1}`}
                            top20AlertData={this.props.top20AlertData}
                            updateAlertStatusReq={this.props.updateAlertStatusReq}
                            getElementDetailReq={this.props.getElementDetailReq}
                            toggleAlertNotificationPopover={this.toggleAlertNotificationPopover}
                            isOpenAlertNotification={this.state.isOpenAlertNotification}
                            getInboxAlertByUserReq={this.props.getInboxAlertByUserReq}
                            notificationDetail={item}
                          />
                        ))}
                        <div className="alert-bottom-box">
                          <span
                            className={isHighbondUsers ? 'alert-bottom-section disabled' : 'alert-bottom-section'}
                            onClick={() => {
                              if (!isHighbondUsers) {
                                history.push(pathConst.MY_ALERT_INBOX);
                                this.toggleAlertNotificationPopover();
                              }
                            }}
                          >
                            View all alerts here
                          </span>
                        </div>
                        {/*  */}
                      </div>
                    ) : (
                      <>
                        <div className="no-alert-box">
                          <span
                            className={isHighbondUsers ? 'alert-bottom-section disabled' : 'alert-bottom-section'}
                            onClick={() => {
                              if (!isHighbondUsers) {
                                history.push(pathConst.MY_ALERT_NEW);
                                this.toggleAlertNotificationPopover();
                              }
                            }}
                          >
                            <svg
                              className="svg-icon"
                              style={{
                                width: '1.3em',
                                height: '1.3em',
                                verticalAlign: 'middle',
                                fill:
                                  this.props.trialProductStatus &&
                                  this.props.trialProductStatus !== TypeConstants.NOT_TRIAL_USER
                                    ? '#1E1E1E'
                                    : 'white',
                                overflow: 'hidden',
                              }}
                              viewBox="0 0 1024 1024"
                              version="1.1"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path d="M426.666667 896C426.666667 943.36 465.066667 981.333333 512 981.333333 558.933333 981.333333 597.333333 942.933333 597.333333 896M805.546667 717.653333 805.546667 469.333333C805.546667 330.666667 709.546667 214.613333 579.84 183.893333L579.84 153.173333C579.84 115.626667 549.546667 85.333333 512 85.333333 474.453333 85.333333 444.16 115.626667 444.16 153.173333L444.16 183.893333C314.453333 214.613333 218.453333 330.666667 218.453333 469.333333L218.453333 717.653333 128 808.106667 128 853.333333 896 853.333333 896 808.106667M682.666667 554.666667 554.666667 554.666667 554.666667 682.666667 469.333333 682.666667 469.333333 554.666667 341.333333 554.666667 341.333333 469.333333 469.333333 469.333333 469.333333 341.333333 554.666667 341.333333 554.666667 469.333333 682.666667 469.333333" />
                            </svg>
                            Create alerts here{' '}
                          </span>
                        </div>
                      </>
                    )}
                  </div>
                </SlideDown>
              </div>
            </span>
          </li>

          <li className="d-inline-flex nav-item">
            <span
              id="navbarDropdown"
              className="nav-link"
              role="button"
              onClick={this.toggleUserCardPopover}
              style={{ position: 'relative' }}
            >
              {' '}
              <svg
                className="svg-icon"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12.0397 17.2631C14.9392 17.2631 17.2897 14.9126 17.2897 12.0131C17.2897 9.11363 14.9392 6.76312 12.0397 6.76312C9.14025 6.76312 6.78975 9.11363 6.78975 12.0131C6.78975 14.9126 9.14025 17.2631 12.0397 17.2631Z"
                  stroke={
                    this.props.trialProductStatus && this.props.trialProductStatus !== TypeConstants.NOT_TRIAL_USER
                      ? '#1E1E1E'
                      : 'white'
                  }
                  strokeWidth="1.5"
                  strokeMiterlimit="10"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M22.575 10.224L20.7345 9.74775C20.5249 8.94667 20.2051 8.17858 19.7843 7.4655L20.7615 5.80575C20.8627 5.63388 20.904 5.43327 20.8788 5.23541C20.8536 5.03755 20.7634 4.85366 20.6224 4.71263L19.3433 3.4335C19.2022 3.29246 19.0183 3.20227 18.8205 3.17708C18.6226 3.1519 18.422 3.19316 18.2501 3.29437L16.5915 4.26938C15.8769 3.84727 15.107 3.52669 14.304 3.31688L13.8158 1.425C13.7659 1.2318 13.6532 1.06065 13.4954 0.938463C13.3377 0.816278 13.1438 0.749983 12.9443 0.75H11.1349C10.9354 0.750066 10.7416 0.816399 10.5839 0.938578C10.4262 1.06076 10.3136 1.23186 10.2638 1.425L9.77625 3.3105C8.96785 3.51941 8.19269 3.84053 7.47338 4.2645L5.778 3.26625C5.60613 3.16503 5.40552 3.12378 5.20766 3.14896C5.0098 3.17414 4.82591 3.26434 4.68488 3.40538L3.40538 4.68488C3.26434 4.82591 3.17414 5.0098 3.14896 5.20766C3.12378 5.40552 3.16503 5.60613 3.26625 5.778L4.2645 7.473C3.84836 8.17962 3.53139 8.94012 3.3225 9.73312L1.425 10.224C1.2318 10.2739 1.06065 10.3866 0.938463 10.5443C0.816278 10.7021 0.749983 10.896 0.75 11.0955V12.9049C0.750066 13.1044 0.816399 13.2982 0.938578 13.4558C1.06076 13.6135 1.23186 13.7261 1.425 13.776L3.3075 14.2635C3.51732 15.0814 3.84192 15.8654 4.27163 16.5922L3.29663 18.2509C3.19541 18.4227 3.15415 18.6234 3.17933 18.8212C3.20452 19.0191 3.29471 19.203 3.43575 19.344L4.71525 20.6235C4.85628 20.7645 5.04017 20.8547 5.23803 20.8799C5.43589 20.9051 5.63651 20.8638 5.80838 20.7626L7.46813 19.785C8.19392 20.2136 8.97666 20.5374 9.79313 20.7469L10.2638 22.575C10.3136 22.7681 10.4262 22.9392 10.5839 23.0614C10.7416 23.1836 10.9354 23.2499 11.1349 23.25H12.9443C13.1438 23.25 13.3377 23.1837 13.4954 23.0615C13.6532 22.9394 13.7659 22.7682 13.8158 22.575L14.2909 20.7375C15.1013 20.5267 15.8782 20.2032 16.5986 19.7764L18.222 20.7323C18.3939 20.8335 18.5945 20.8747 18.7923 20.8495C18.9902 20.8244 19.1741 20.7342 19.3151 20.5931L20.5946 19.3136C20.7357 19.1726 20.8259 18.9887 20.851 18.7908C20.8762 18.593 20.835 18.3924 20.7337 18.2205L19.7779 16.5971C20.2118 15.865 20.539 15.0746 20.7495 14.25L22.5754 13.7775C22.7687 13.7275 22.9399 13.6146 23.062 13.4566C23.1842 13.2987 23.2503 13.1046 23.25 12.9049V11.0955C23.25 10.896 23.1837 10.7021 23.0615 10.5443C22.9394 10.3866 22.7682 10.2739 22.575 10.224Z"
                  stroke={
                    this.props.trialProductStatus && this.props.trialProductStatus !== TypeConstants.NOT_TRIAL_USER
                      ? '#1E1E1E'
                      : 'white'
                  }
                  strokeWidth="1.5"
                  strokeMiterlimit="10"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <div
                className={this.state.isOpenUserCardPopover ? bem.b('dropdown-menu show') : bem.b('dropdown-menu')}
                aria-labelledby="navbarDropdown"
                style={{ zIndex: 1003 }}
              >
                <SlideDown className="my-dropdown-slidedown">
                  <div
                    className={bem.b('card')}
                    onClick={(e) => {
                      e.stopPropagation();
                    }}
                  >
                    <div className={bem.b('card-header')}>
                      {this.state.highbondUserInfo ? (
                        <> {this.state.highbondUserInfo.email}</>
                      ) : (
                        <>
                          {' '}
                          {this.state.UserEmailName} <br /> {this.state.UserEmailDomain}
                        </>
                      )}
                    </div>
                    <div className="card-body">
                      <ul className="list-group list-group-flush">
                        <li className="list-group-item">
                          <span
                            onClick={(e) => {
                              e.preventDefault();
                              history.push(pathConst.PREFERENCES);
                              this.toggleUserCardPopover();
                            }}
                          >
                            Preferences
                          </span>
                        </li>
                        <li
                          className={isHighbondUsers ? 'list-group-item cursor-auto' : 'list-group-item cursor-pointer'}
                        >
                          <span
                            onClick={(e) => {
                              e.preventDefault();
                              if (!isHighbondUsers) {
                                history.push(pathConst.MY_ALERT_NEW);
                                this.toggleUserCardPopover();
                              }
                            }}
                          >
                            {isHighbondUsers ? this.renderComingSoonTag() : 'My Alerts'}
                          </span>
                        </li>
                        <li className="list-group-item">
                          <span
                            onClick={(e) => {
                              e.preventDefault();
                              history.push(pathConst.RECENT_DOWNLOADS);
                              this.toggleUserCardPopover();
                            }}
                          >
                            Recent Downloads
                          </span>
                        </li>
                        <li className="list-group-item">
                          <span
                            onClick={(e) => {
                              e.preventDefault();
                              history.push(pathConst.GENERAL_FAQ);
                              this.toggleUserCardPopover();
                            }}
                          >
                            FAQ / Help
                          </span>
                        </li>
                        <li style={{ listStyleType: 'none', background: 'white' }}>
                          <div className="list-group-innertitle">
                            <span>Modules Available:</span>
                            <ul className="innerlist-group">
                              {this.state.Membership.map(
                                (membership, index) =>
                                  membership.status !== FORBIDDEN_USER && (
                                    <li
                                      key={Math.random()}
                                      className={`innerlist-group-item ${
                                        this.state.Membership.length - 2 === index ? 'pb-0' : ''
                                      } ${
                                        membership.product_id === ACTIVIST_INSIGHT_MONTHLY
                                          ? 'listitem-insightia-monthly pt-2 pb-2'
                                          : ''
                                      } ${
                                        membership.product_id === ACTIVIST_INSIGHT_MONTHLY
                                          ? 'active'
                                          : membership.status === FULL_USER || membership.status === TRIAL_USER
                                            ? 'active'
                                            : ''
                                      }`}
                                    >
                                      {membership.status === TRIAL_USER ? (
                                        <span>
                                          {membership.short_name}&nbsp;
                                          <span className={bem.e('trial-lable')}>
                                            (Trial expires - {dateToNull(membership.end_date, 'dd-mmm')})
                                          </span>
                                        </span>
                                      ) : (
                                        membership.status !== FORBIDDEN_USER && (
                                          <span
                                            className="moduleList"
                                            onClick={() => {
                                              if (history.location.pathname === pathConst.DASHBOARD) {
                                                this.props.handleDashboardFromModule(membership.product_id);
                                                this.toggleUserCardPopover();
                                              } else {
                                                history.push(pathConst.DASHBOARD);
                                                this.props.handleDashboardFromModule(membership.product_id);
                                                this.toggleUserCardPopover();
                                              }
                                            }}
                                          >
                                            {membership.short_name}{' '}
                                          </span>
                                        )
                                      )}
                                    </li>
                                  ),
                              )}
                            </ul>
                          </div>
                        </li>
                      </ul>
                    </div>
                    <div className="card-footer text-muted">
                      <span className="btn btn-link" onClick={this.handleLogout}>
                        Sign out
                      </span>
                    </div>
                  </div>
                </SlideDown>
              </div>
            </span>
          </li>
        </ul>
      </nav>
    );
  }
}

const mapDispatchToProps = { toggleSideBar };

export default connect(null, mapDispatchToProps)(React.memo(Header));
